import type { CreatureDerivedJumpInput, CreatureDerivedJumpResult, CreatureSpeedSource } from '../types';

/** Derive jumping distance from an already-resolved positive walking speed and Body. */
export function compileCreatureDerivedJump(input: CreatureDerivedJumpInput): CreatureDerivedJumpResult {
    const body = Math.max(0, Math.trunc(input.body));
    const walkPart = Math.ceil(input.walk / 3);
    const bodyPart = 2 * body;
    const total = Math.max(10, Math.ceil((input.walk / 3) + bodyPart));
    const sources: CreatureSpeedSource[] = [{
        category: 'derived',
        label: `⅓ × Walking Speed (${Math.round(input.walk)})`,
        value: walkPart,
        href_id: '',
        kind: 'speed_walking',
    }];
    if (bodyPart !== 0) sources.push({
        category: 'derived',
        label: `2 ft × Body (${body})`,
        value: bodyPart,
        href_id: '',
        kind: 'body',
    });
    const baseSum = walkPart + bodyPart;
    if (baseSum < total) sources.push({
        category: 'derived',
        label: 'Minimum jump distance',
        value: total - baseSum,
        href_id: '',
        kind: 'speed_jumping',
    });
    return { total, base: 0, locked: false, sources, breakdown: { derived: total }, derived: true };
}
